import { Link } from 'react-router-dom';

export default function CtaSection({ reveal = 'rv' }: { reveal?: string }) {
  return (
    <section className="fin2 pur">
      <div className="flt">
        <span className="fico" style={{ left: "8%", top: "18%", width: "76px", height: "76px", animationDelay: "0s" }}>
          <img src="/site/logos/notion.svg" alt="" />
        </span>
        <span className="fico" style={{ left: "20%", top: "62%", width: "60px", height: "60px", color: "#22BFCA", animationDelay: "-1.2s" }}>
          <svg className="i">
            <use href="#msg" />
          </svg>
        </span>
        <span className="fico" style={{ left: "4%", top: "70%", width: "52px", height: "52px", animationDelay: "-2s" }}>
          <img src="/site/logos/gmail.svg" alt="" />
        </span>
        <span className="fico" style={{ left: "26%", top: "14%", width: "48px", height: "48px", color: "#3B82F6", animationDelay: "-3s" }}>
          <svg className="i">
            <use href="#doc" />
          </svg>
        </span>
        <span className="fico" style={{ left: "15%", top: "40%", width: "44px", height: "44px", animationDelay: "-0.6s" }}>
          <img src="/site/logos/aws.svg" alt="" />
        </span>
        <span className="fico" style={{ left: "84%", top: "16%", width: "72px", height: "72px", animationDelay: "-1.6s" }}>
          <img src="/site/logos/openai.svg" alt="" />
        </span>
        <span className="fico" style={{ left: "74%", top: "64%", width: "62px", height: "62px", color: "#EC4899", animationDelay: "-0.4s" }}>
          <svg className="i">
            <use href="#spark" />
          </svg>
        </span>
        <span className="fico" style={{ left: "90%", top: "60%", width: "54px", height: "54px", animationDelay: "-2.6s" }}>
          <img src="/site/logos/naver.svg" alt="" />
        </span>
        <span className="fico" style={{ left: "70%", top: "18%", width: "46px", height: "46px", color: "#F59E0B", animationDelay: "-3.4s" }}>
          <svg className="i">
            <use href="#db" />
          </svg>
        </span>
        <span className="fico" style={{ left: "82%", top: "40%", width: "44px", height: "44px", animationDelay: "-1s" }}>
          <img src="/site/logos/gemini.svg" alt="" />
        </span>
      </div>
      <div className={`wrap ${reveal}`}>
        <span className="axb">
          <img src="/site/logos/ax-symbol.svg" alt="AcXion-On" />
        </span>
        <h2>
          우리 조직의 AI Agent
          <br />
          AcXion-On으로 시작해보세요.
        </h2>
        <p>데이터 연결부터 AI Agent 제작·배포까지 한곳에서</p>
        <div className="cta">
          <Link className="btn w" to="/contact">무료 체험</Link>
          <Link className="btn gh" to="/contact">문의하기</Link>
        </div>
      </div>
    </section>
  );
}
